module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4fc11c4215ee1b7b714ebeedbdd24392.png";